import { render, staticRenderFns } from "./printerRecord.vue?vue&type=template&id=27ddd9fd&scoped=true"
import script from "./printerRecord.vue?vue&type=script&lang=js"
export * from "./printerRecord.vue?vue&type=script&lang=js"
import style0 from "./printerRecord.vue?vue&type=style&index=0&id=27ddd9fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddd9fd",
  null
  
)

export default component.exports